<!-- NotesApp Source File: header.component.html  -->
<app-config class="hidden" />

<div class="bg-surface-100 dark:bg-surface-950 p-0.5 flex flex-col gap-6">
  <div class="flex-row">
    <!-- Mobile App-Head pane -->
    <div
      class="sm:hidden flex sticky top-0 z-50 flex-grow space-x-1 text-l justify-center items-center p-.5 bg-surface-0 dark:bg-surface-900 rounded-2xl mx-auto border border-surface-200 dark:border-surface-700 w-full">
      <p-tieredMenu
        class="ml-0 mt-6 text-l font-light text-surface-700 dark:text-surface-100 leading-none"
        #mobmenu
        [model]="pageMenuItems"
        [popup]="true"
        appendTo="body">
      </p-tieredMenu>

      <!-- Trigger button -->
      <a
        class="relative cursor-pointer text-surface-700 dark:text-surface-100 leading-none"
        (click)="togglePageMenu($event, mobmenu)">
        <i class="pi pi-bars"></i>
      </a>
      <div class="w20">Notes</div>
      <span
        class="cursor-pointer select-none ml-0"
        [class]="isOnline ? 'online' : 'offline'"
        (click)="onSelectPageMenuItem('Synchronisation')"
        [title]="connectivityLabel + ' — click for sync status'">
        {{ isOnline ? '🟢' : '🔴' }}
      </span>
      <p-menu
        #mobileSearchTypeMenu
        [model]="mobileSearchTypeMenuItems"
        [popup]="true"
        appendTo="body"
        [autoZIndex]="true"
        [baseZIndex]="1000"
        class="hidden"></p-menu>
      <div class="group relative flex p-0.5 h-10 flex-grow">
        <input
          pInputText
          #MobileSearchField
          class="flex-grow w-30 max-w-5xl min-w-0 mx-1 p-1 pr-16 border border-surface-300 dark:border-surface-600 bg-surface-0 dark:bg-surface-800 text-color rounded"
          [ngClass]="{ 'filter-active-border': isSearchStringActive }"
          type="text"
          placeholder="Search"
          [(ngModel)]="filter.SearchString"
          (input)="onSearch(MobileSearchField.value)"
          autofocus />
        <button
          class="mobile-search-type-btn absolute right-10 top-1/2 -translate-y-1/2 p-1 text-gray-500 dark:text-surface-200 hover:text-gray-700 border-0 bg-transparent"
          [ngClass]="{ 'filter-active-border': isSearchTypeActive }"
          type="button"
          (click)="mobileSearchTypeMenu.toggle($event)"
          aria-label="Choose search type">
          <i class="pi pi-sliders-h"></i>
        </button>
        <button
          class="absolute right-2 top-1/2 transform -translate-y-1/2 p-1 mr-0 hover:text-gray-700 border-0 bg-transparent"
          type="button"
          (click)="clearSearchField()">
          <i class="pi pi-times text-red-500"></i>
        </button>
      </div>
      <div class="FilterMenu">
        <p-menu
          #filtermenu
          [model]="filterMenuItems"
          [popup]="true"
          appendTo="body"
          [autoZIndex]="true"
          [baseZIndex]="1000" />

        <a
          class="mx-1 relative cursor-pointer text-primary dark:text-primary-contrast leading-none"
          title="Open filter menu"
          (click)="filtermenu.toggle($event)">
          <i class="pi pi-filter"></i>
        </a>
      </div>
    </div>
    <div class="sm:hidden flex mx-1 items-center gap-2 flex-wrap">
      <div class="flex items-center gap-1 flex-[2] min-w-[0] w-full max-w-full">
        <p-select
          [(ngModel)]="selectedSavedSearchId"
          [options]="savedSearches"
          optionLabel="name"
          optionValue="id"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          placeholder="Saved Search/Filter"
          appendTo="body"
          panelStyleClass="header-saved-search-panel"
          class="header-saved-search-select-mobile h-9 text-sm"
          [ngClass]="{ 'filter-active-border': !!selectedSavedSearchId }"
          (onChange)="onSavedSearchSelected($event.value)"
          (onShow)="focusSavedSearchFilterInput()">
        </p-select>

        <!-- Advanced tag filter button (mobile) — opens the shared dialog -->
        <button
          type="button"
          pButton
          class="advanced-tag-btn flex-shrink-0 h-9"
          [class.advanced-tag-btn--active]="isAdvancedTagFilterActive"
          (click)="openAdvancedTagFilterDialog()"
          title="Advanced tag filter">
          <i class="pi pi-sliders-h"></i>
        </button>
      </div>
      <a
        class="px-2 py-1 cursor-pointer text-red-500 dark:text-surface-100 leading-none flex-shrink-0"
        (click)="onSelectPageMenuItem('Refresh')"
        title="Refresh the page"
        aria-label="">
        <i class="pi pi-refresh"></i>
      </a>
    </div>

    <!-- Large-Screen App-Head pane -->
    <div
      #desktopHeaderPane
      class="hidden sm:block sticky top-0 z-50 space-x-3 justify-center items-center p-1 bg-surface-0 dark:bg-surface-900 rounded-2xl mx-auto border border-surface-500 dark:border-surface-700 w-full">
      <div class="flex my-2 items-center">
        <!-- <p-menu #menu [model]="pageMenuItems" [popup]="true" appendTo="body" [autoZIndex]="true"
                    [baseZIndex]="1000" [style]="{ marginTop: '8px' }"
                    class="ml-4 text-xl font-light bg-surface-200 text-surface-700 dark:text-surface-100 leading-none !z-1000"></p-menu> -->
        <p-tieredMenu
          class="ml-1 mt-6 text-xl font-light text-surface-700 dark:text-surface-100 leading-none !z-1000"
          #menu
          [model]="pageMenuItems"
          [popup]="true"
          styleClass="custom-menu-pane"
          appendTo="body">
        </p-tieredMenu>

        <a
          #menuBtn
          class="relative cursor-pointer text-primary dark:text-surface-100 leading-none font-bold text-2xl"
          (click)="togglePageMenu($event, menu)"
          aria-label="Menu">
          <i class="pi pi-bars"></i>
        </a>

        <div
          class="ml-2 mr-4 w-[190px] min-w-[190px] text-2xl font-bold whitespace-nowrap"
          style="color: var(--p-primary-color);">
          NotesApp V4 Prod
        </div>
        <p-button
          size="small"
          styleClass="ml-4 mr-4 p-button-rounded p-button-outlined ai-launch-btn"
          label="AI"
          icon="pi pi-sparkles"
          (onClick)="onSelectPageMenuItem('AI')">
        </p-button>
        <a
          class="mx-2 cursor-pointer text-red-500 dark:text-surface-100 leading-none"
          (click)="onSelectPageMenuItem('Refresh')"
          aria-label="">
          <i class="pi pi-refresh"></i>
        </a>

        <span
          class="cursor-pointer select-none"
          [class]="isOnline ? 'online' : 'offline'"
          (click)="onSelectPageMenuItem('Synchronisation')"
          [title]="connectivityLabel + ' — click for sync status'">
          {{ isOnline ? '🟢' : '🔴' }}
        </span>
        <div class="group relative flex p-1 h-10 w-full items-center">
          <!-- Search input -->
          <input
            type="text"
            pInputText
            [(ngModel)]="filter.SearchString"
            placeholder="Search"
            #DesktopSearchField
            class="flex-grow mx-2 p-1 border text-sm pr-24 min-w-[200px]"
            [ngClass]="{ 'filter-active-border': isSearchStringActive }"
            style="width: 100%; max-width: 100%;"
            autofocus
            (input)="onSearch($any($event.target).value)" />

          <!-- 🔽 Search type select -->
          <select
            [(ngModel)]="filter.SearchType"
            (change)="setSearchType($any($event.target).value)"
            class="absolute right-10 top-1/2 transform -translate-y-1/2 text-sm border rounded-md bg-white text-gray-700 pr-6 pl-2 h-7 appearance-none cursor-pointer"
            [ngClass]="{ 'filter-active-border': isSearchTypeActive }">
            <option value="Semantic">Semantic</option>
            <option value="Full text">Full text</option>
            <option value="Title only">Title only</option>
            <option value="Title & Tags">Title & Tags</option>
            <option value="Tags only">Tags only</option>
            <option value="Title & Keywords">Title & Keywords</option>
            <option value="Title, Keywords & Tags">Title, Keywords & Tags</option>
            <option value="Keywords only">Keywords only</option>
            <option value="ID">ID</option>
          </select>

          <!-- ❌ Clear button -->
          <button
            class="absolute right-2 top-1/2 transform -translate-y-1/2 p-2 text-gray-500 hover:text-gray-700 border-0 bg-transparent"
            type="button"
            (click)="clearSearchField()">
            <i class="pi pi-times text-red-500"></i>
          </button>
        </div>

        <!-- Right menu -->
        <div class="flex-grow"></div>
        <p-menu
          #userMenu
          [model]="userMenuItems"
          [popup]="true"
          appendTo="body"
          [autoZIndex]="true"
          [baseZIndex]="1000"></p-menu>
        <a
          #userMenuBtn
          class="relative cursor-pointer text-primary dark:text-surface-100 leading-none"
          (click)="userMenu.toggle($event)"
          aria-label="User Menu">
          <span class="material-symbols-outlined text-base">person_4</span>
        </a>
      </div>
      <!-- filter row -->
      <div
        #desktopFilterRow
        class="flex mx-1 items-center flex-nowrap overflow-hidden gap-1 filter-row"
        [ngClass]="{
          'filter-row--compact-actions': filterRowMode === 'compact-actions' || filterRowMode === 'compact-priority',
          'filter-row--compact-priority': filterRowMode === 'compact-priority'
        }">
        <p-splitButton
          size="small"
          severity="danger"
          styleClass="p-0 color-red-500 header-filter-button header-filter-button--clear header-filter-clear-split"
          label="Clear"
          icon="pi pi-filter-slash"
          [model]="clearMenuItems"
          [attr.title]="clearFilterTooltip"
          (onClick)="clearSearchAndFilters()">
        </p-splitButton>
        <div class="header-saved-search-shell">
          <p-select
            [(ngModel)]="selectedSavedSearchId"
            [options]="savedSearches"
            optionLabel="name"
            optionValue="id"
            [filter]="true"
            filterBy="name"
            [showClear]="true"
            placeholder="Saved Search/Filter"
            appendTo="body"
            panelStyleClass="header-saved-search-panel"
            class="header-saved-search-select h-9 text-sm"
            [ngClass]="{ 'filter-active-border': !!selectedSavedSearchId }"
            (onChange)="onSavedSearchSelected($event.value)"
            (onShow)="focusSavedSearchFilterInput()">
          </p-select>
        </div>
        <div class="flex items-center header-tags-filter-shell">
          <button
            type="button"
            pButton
            class="header-filter-button header-filter-button--tags"
            [ngClass]="{ 'filter-active-border': isTagFilterActive }"
            (click)="toggleQuickTagPopover($event, quickTagPopover)"
            [title]="tagFilterTooltipLabel"
            aria-label="Filter by tags">
            <span class="material-symbols-outlined header-tags-filter-btn__icon" aria-hidden="true">label</span>
            <span class="header-tags-filter-btn__label">{{ tagFilterButtonLabel }}</span>
          </button>

          <p-popover
            #quickTagPopover
            [dismissable]="true"
            [focusOnShow]="false"
            appendTo="body"
            styleClass="header-tags-filter-popover"
            (onShow)="onQuickTagPopoverShow()">
            <div class="header-tags-filter-popover__content">
              <div class="header-tags-filter-popover__title">Filter by tags</div>

              <input
                #quickTagSearchField
                type="text"
                pInputText
                [(ngModel)]="quickTagSearch"
                placeholder="Search tags"
                class="w-full text-sm header-tags-filter-popover__search" />

              <div *ngIf="selectedQuickTagOptions.length > 0" class="header-tags-filter-popover__selected">
                <div class="header-tags-filter-popover__selected-title">Selected tags</div>
                <div class="header-tags-filter-popover__selected-list">
                  <button
                    *ngFor="let tag of selectedQuickTagOptions"
                    type="button"
                    class="header-tags-filter-popover__selected-chip"
                    [style.borderColor]="tag.color || '#2563eb'"
                    [style.backgroundColor]="tag.color || '#2563eb'"
                    (click)="toggleQuickTag(tag._id)">
                    <span class="header-tags-filter-popover__selected-chip-label">{{ tag.name }}</span>
                    <span class="header-tags-filter-popover__selected-chip-remove" aria-hidden="true">×</span>
                  </button>
                </div>
              </div>

              <div class="header-tags-filter-popover__list">
                <button
                  *ngFor="let tag of quickTagOptions"
                  type="button"
                  class="header-tags-filter-popover__item"
                  [class.header-tags-filter-popover__item--active]="isQuickTagSelected(tag._id)"
                  (click)="toggleQuickTag(tag._id)">
                  <span class="header-tag-option">
                    <input
                      type="checkbox"
                      class="header-tags-filter-popover__checkbox"
                      [checked]="isQuickTagSelected(tag._id)"
                      (click)="$event.stopPropagation()"
                      (change)="toggleQuickTag(tag._id)" />
                    <span class="header-tag-option__swatch" [style.backgroundColor]="tag.color || '#94a3b8'"></span>
                    <span class="header-tag-option__label">{{ tag.name }}</span>
                  </span>
                </button>
                <div *ngIf="quickTagOptions.length === 0" class="header-tags-filter-popover__empty">
                  No tags match.
                </div>
              </div>

              <div class="header-tags-filter-popover__actions">
                <p-button
                  label="Clear"
                  severity="secondary"
                  size="small"
                  (onClick)="clearQuickTagFilter()">
                </p-button>
                <p-button
                  label="Advanced"
                  icon="pi pi-sliders-h"
                  size="small"
                  (onClick)="openAdvancedFromQuickTag(quickTagPopover)">
                </p-button>
              </div>
            </div>
          </p-popover>
        </div>
        <div class="flex items-center ml-2 header-date-filter-shell">
          <button
            type="button"
            pButton
            class="header-filter-button header-filter-button--date"
            [ngClass]="{ 'filter-active-border': isDateFilterActive }"
            (click)="dateFilterPopover.toggle($event)"
            [title]="dateFilterTooltipLabel"
            aria-label="Filter by date">
            <span class="material-symbols-outlined header-date-filter-btn__icon" aria-hidden="true">calendar_month</span>
            <span class="header-date-filter-btn__label">{{ dateFilterButtonLabel }}</span>
          </button>

          <p-popover
            #dateFilterPopover
            [dismissable]="true"
            appendTo="body"
            styleClass="header-date-filter-popover">
            <div class="header-date-filter-popover__content">
              <div class="header-date-filter-popover__title">Filter by date</div>

              <p-select
                [options]="dateFieldOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="dateFilterField"
                appendTo="body"
                placeholder="Date field"
                (onChange)="onDateFilterFieldChange($event.value)">
              </p-select>

              <p-select
                [options]="dateModeOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="dateFilterMode"
                appendTo="body"
                placeholder="Since mode"
                (onChange)="onDateFilterModeChange($event.value)">
              </p-select>

              <div *ngIf="dateFilterMode === 'days'" class="header-date-filter-popover__days">
                <p-inputNumber
                  inputId="dateSinceDays"
                  [(ngModel)]="dateSinceDays"
                  [useGrouping]="false"
                  [min]="1"
                  [showButtons]="true"
                  [step]="1"
                  placeholder="Days"
                  (ngModelChange)="onDateSinceDaysChange($event)">
                </p-inputNumber>
                <div class="header-date-filter-popover__quick-days">
                  <p-button
                    *ngFor="let option of sinceDayQuickOptions"
                    size="small"
                    severity="secondary"
                    [outlined]="dateSinceDays !== option.value"
                    [label]="option.label"
                    (onClick)="onDateQuickPick(option.value)">
                  </p-button>
                </div>
              </div>

              <p-datepicker
                *ngIf="dateFilterMode === 'date'"
                inputId="dateSinceSpecific"
                [showIcon]="true"
                dateFormat="dd.mm.yy"
                [(ngModel)]="dateSinceDate"
                (ngModelChange)="onDateSinceDateChange($event)">
              </p-datepicker>

              <div class="header-date-filter-popover__actions">
                <p-button
                  label="Clear"
                  severity="secondary"
                  size="small"
                  (onClick)="clearDateFilters(); dateFilterPopover.hide()">
                </p-button>
              </div>
            </div>
          </p-popover>
        </div>
        <div class="mx-2">
          <p-select
            [options]="statusFilterOptions"
            appendTo="body"
            [panelStyleClass]="'status-select-panel project-status-panel'"
            class="!p-0 mx-2 my-0 text-sm leading-none h-9 w-36 status-select"
            [ngClass]="{ 'filter-active-border': isStatusFilterActive }"
            [(ngModel)]="selectedStatus"
            (onChange)="onStatusChanged($event.value)"
            placeholder="Status"
            aria-label="Status filter">
          </p-select>
        </div>
        <div class="flex items-center gap-2 header-quick-actions">
          <p-button
            size="small"
            styleClass="p-0 header-filter-button header-filter-button--action"
            label="Next Actions"
            title="Show only Next Action items"
            (onClick)="onSelectFilterMenuItem('NextActions')">
              <span class="material-symbols-outlined text-base">priority_high</span>
          </p-button>
          <p-button
            size="small"
            styleClass="p-0 !bg-blue-500 header-filter-button header-filter-button--action"
            label="NotesApp"
            title="Filter to NotesApp category"
            (onClick)="onSelectFilterMenuItem('NotesApp')">
              <span class="material-symbols-outlined text-base">book_5</span>
          </p-button>
          <p-button
            size="small"
            styleClass="p-0 !bg-orange-500 header-filter-button header-filter-button--action"
            label="Work"
            title="Filter to Work (Optra) category"
            (onClick)="onSelectFilterMenuItem('Optra')">
              <span class="material-symbols-outlined text-base">apartment</span>
          </p-button>
          <p-button
            size="small"
            styleClass="p-0 header-filter-button header-filter-button--action"
            label="Shopping"
            title="Filter to Shopping category"
            (onClick)="onSelectFilterMenuItem('Shopping')">
            <span class="material-symbols-outlined text-base">shopping_cart</span> 
          </p-button>   
          <p-button
            size="small"
            styleClass="p-0 header-filter-button header-filter-button--action"
            label="Food"
            title="Filter to Food category"
            (onClick)="onSelectFilterMenuItem('Food')">
            <span class="material-symbols-outlined text-base">restaurant</span>
          </p-button>
          <p-button
            size="small"
            styleClass="p-0 header-filter-button header-filter-button--action"
            label="KB"
            title="Filter to Knowledge Base type"
            (onClick)="onSelectFilterMenuItem('KnowledgeBase')">
            <span class="material-symbols-outlined text-base">menu_book</span>
          </p-button>
          <p-button
            size="small"
            styleClass="p-0 header-filter-button header-filter-button--action"
            title="new Calendar window"
            aria-label="New Calendar window"
            (onClick)="openNewCalendarWindow()">
            <span class="material-symbols-outlined text-base">calendar_month</span>
          </p-button>
        </div>
        <span
          class="text-xs w-5 flex-grow text-right font-light text-surface-700 dark:text-surface-100 leading-none whitespace-nowrap"
          >{{ auth.getFormattedRemainingTime() }}</span
        >
      </div>
      <!-- End of filter-container -->
    </div>
    <!-- END Large-Screen App-Head pane -->
  </div>
</div>

<!-- ============================================================
     Shared: Advanced Tag Filter content template
     Used by the desktop p-popover and the mobile p-dialog.
     ============================================================ -->
<ng-template #advancedTagFilterContent>
  <div class="advanced-tag-filter-panel">
    <div class="advanced-tag-filter-panel__title">Advanced Tag Filter</div>

    <!-- Include tags -->
    <div class="advanced-tag-filter-panel__group">
      <label class="advanced-tag-filter-panel__label advanced-tag-filter-panel__label--include">
        <i class="pi pi-plus-circle"></i> Include Tags
      </label>
      <p-select
        [options]="includeTagModeOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="pendingIncludeTagMode"
        appendTo="body"
        styleClass="w-full advanced-tag-filter-panel__mode-select">
      </p-select>
      <p-multiselect
        [options]="sortedTagOptions"
        optionLabel="name"
        optionValue="_id"
        [(ngModel)]="pendingIncludeTagIds"
        [filter]="true"
        [showClear]="true"
        display="chip"
        placeholder="Select tags to include"
        appendTo="body"
        [scrollHeight]="'40vh'"
        styleClass="w-full"
        (onChange)="onAdvancedIncludeChange($event.value)">
        <ng-template let-tag pTemplate="item">
          <div class="header-tag-option">
            <span class="header-tag-option__swatch" [style.backgroundColor]="tag.color || '#94a3b8'"></span>
            <span>{{ tag.name }}</span>
          </div>
        </ng-template>
      </p-multiselect>
      <span class="advanced-tag-filter-panel__hint">
        {{ pendingIncludeTagMode === 'OR' ? 'Note must contain ANY selected include tag (OR logic)' : 'Note must contain ALL selected include tags (AND logic)' }}
      </span>
    </div>

    <!-- Exclude tags -->
    <div class="advanced-tag-filter-panel__group">
      <label class="advanced-tag-filter-panel__label advanced-tag-filter-panel__label--exclude">
        <i class="pi pi-minus-circle"></i> Exclude Tags
      </label>
      <p-multiselect
        [options]="sortedTagOptions"
        optionLabel="name"
        optionValue="_id"
        [(ngModel)]="pendingExcludeTagIds"
        [filter]="true"
        [showClear]="true"
        display="chip"
        placeholder="Select tags to exclude"
        appendTo="body"
        [scrollHeight]="'40vh'"
        styleClass="w-full"
        (onChange)="onAdvancedExcludeChange($event.value)">
        <ng-template let-tag pTemplate="item">
          <div class="header-tag-option">
            <span class="header-tag-option__swatch" [style.backgroundColor]="tag.color || '#94a3b8'"></span>
            <span>{{ tag.name }}</span>
          </div>
        </ng-template>
      </p-multiselect>
      <span class="advanced-tag-filter-panel__hint">Notes with ANY of these tags are hidden</span>
    </div>

    <!-- Actions -->
    <div class="advanced-tag-filter-panel__actions">
      <p-button
        label="Clear All"
        severity="secondary"
        size="small"
        icon="pi pi-filter-slash"
        (onClick)="clearAdvancedTagFilter()">
      </p-button>
      <p-button
        label="Cancel"
        severity="secondary"
        size="small"
        icon="pi pi-times"
        (onClick)="cancelAdvancedTagFilter()">
      </p-button>
      <p-button
        label="Apply"
        severity="primary"
        size="small"
        icon="pi pi-check"
        (onClick)="applyAdvancedTagFilter()">
      </p-button>
    </div>
  </div>
</ng-template>

<!-- Advanced tag filter dialog — used on mobile; also triggered from mobile Advanced button -->
<p-dialog
  header="Advanced Tag Filter"
  [(visible)]="advancedTagDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(96vw, 480px)' }"
  [contentStyle]="{ padding: '0' }"
  appendTo="body"
  styleClass="advanced-tag-filter-dialog"
  (onHide)="cancelAdvancedTagFilter()">
  <ng-container *ngTemplateOutlet="advancedTagFilterContent"></ng-container>
</p-dialog>

<p-dialog
  header="Filter by category"
  [(visible)]="categoryFilterDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(96vw, 900px)' }"
  appendTo="body"
  styleClass="header-category-filter-dialog"
  (onHide)="closeCategoryFilterDialog()">
  <div class="flex flex-col gap-3 p-1">
    <p-treeSelect
      class="w-full h-10 text-sm"
      [ngClass]="{ 'filter-active-border': isCategoriesFilterActive }"
      [options]="categoryTreeNodes"
      [(ngModel)]="selectedTreeNodes"
      selectionMode="checkbox"
      [propagateSelectionDown]="true"
      [propagateSelectionUp]="true"
      [filter]="true"
      [metaKeySelection]="false"
      display="comma"
      placeholder="Filter by category"
      scrollHeight="480px"
      appendTo="body"
      panelStyleClass="header-categories-panel"
      [overlayOptions]="{ appendTo: 'body', autoZIndex: true, baseZIndex: 12000 }"
      (ngModelChange)="onTreeCategoryChange($event)">
    </p-treeSelect>

    <div class="flex items-center justify-end gap-2">
      <p-button
        label="All categories"
        severity="secondary"
        size="small"
        icon="pi pi-list"
        (onClick)="clearCategoryFilterFromDialog()">
      </p-button>
      <p-button
        label="Done"
        severity="primary"
        size="small"
        icon="pi pi-check"
        (onClick)="closeCategoryFilterDialog()">
      </p-button>
    </div>
  </div>
</p-dialog>
